import React from 'react';
import CircularBarChart from '../../Charts/CircularBarChart';

const TeamFantasyFitnessScoreCard = ({
	team,
	gradeRanks,
	handleRankClick,
	visibleRankModal,
	handleTeamClick,
	rankModalRef,
	currentTeamRef,
	loading
}) => {
	return (
		<div className="flex flex-wrap border border-gray-300 dark:border-dark-border rounded-xl shadow-lg bg-white dark:bg-dark-card text-gray-800 dark:text-dark-text">
			<div className="pt-6 px-5 md:px-20 flex flex-wrap items-center justify-center lg:justify-between w-full md:flex-row space-y-6 lg:space-y-0">
				<div>
					<CircularBarChart
						loading={loading}
						title="Overall Team Score™"
						chartSize="xl"
						value={
							team && team.recent_overall_team_grade ? (
								team.recent_overall_team_grade
							) : (
								0
							)
						}
						maxPossible={10}
						infoIconText="This is the Overall Team Score™. It combines the team's Passing Score™ and Rushing Score™ to estimate their overall value."
						rank={
							team && team.recent_overall_team_grade_rank ? (
								team.recent_overall_team_grade_rank
							) : (
								999
							)
						}
						abbr_position={null}
						gradeRanks={
							gradeRanks && gradeRanks.overall_grades ? (
								gradeRanks.overall_grades
							) : (
								[]
							)
						}
						handleRankClick={() =>
							handleRankClick(`recent_overall_team_grade_${team.id || 1}`)}
						isRankVisible={
							visibleRankModal === `recent_overall_team_grade_${team.id || 1}`
						}
						rankModalRef={rankModalRef}
						currentTeamRef={currentTeamRef}
						handleTeamClick={handleTeamClick}
						currentTeamId={team && team.id ? team.id : 0}
						hasLabel={true}
						hasRankModalEnabled={true}
						renderFrom="TeamFantasyFitnessScoreCard"
					/>
				</div>
				<div
					className="hidden xl:inline"
					style={{
						borderLeft: '1.5px solid #D1D5DB',
						marginTop: '-1.75rem',
						height: '90%'
					}}
				/>
				<div
					className="lg:hidden inline"
					style={{
						borderBottom: '1.5px solid #D1D5DB',
						width: '100%',
						marginTop: '-1.5rem',
						padding: '20px 0 0 0'
					}}
				/>
				<CircularBarChart
					loading={loading}
					title="Passing Score™"
					chartSize="lg"
					value={
						team && team.recent_passing_grade ? team.recent_passing_grade : 0
					}
					maxPossible={10}
					infoIconText="This is the team's Passing Score™. It measures the team's passing performance based on various metrics."
					rank={
						team && team.recent_passing_grade_rank ? (
							team.recent_passing_grade_rank
						) : (
							999
						)
					}
					abbr_position={null}
					gradeRanks={
						gradeRanks && gradeRanks.passing_grades ? (
							gradeRanks.passing_grades
						) : (
							[]
						)
					}
					handleRankClick={() =>
						handleRankClick(`recent_passing_team_grade_${team.id || 1}`)}
					isRankVisible={
						visibleRankModal === `recent_passing_team_grade_${team.id || 1}`
					}
					rankModalRef={rankModalRef}
					currentTeamRef={currentTeamRef}
					handleTeamClick={handleTeamClick}
					currentTeamId={team && team.id ? team.id : 0}
					hasLabel={true}
					hasRankModalEnabled={true}
					renderFrom="TeamFantasyFitnessScoreCard"
				/>
				<CircularBarChart
					loading={loading}
					title="Rushing Score™"
					chartSize="lg"
					value={
						team && team.recent_rushing_grade ? team.recent_rushing_grade : 0
					}
					maxPossible={10}
					infoIconText="This is the team's Rushing Score™. It measures the team's rushing performance based on various metrics."
					rank={
						team && team.recent_rushing_grade_rank ? (
							team.recent_rushing_grade_rank
						) : (
							999
						)
					}
					abbr_position={null}
					gradeRanks={
						gradeRanks && gradeRanks.rushing_grades ? (
							gradeRanks.rushing_grades
						) : (
							[]
						)
					}
					handleRankClick={() =>
						handleRankClick(
							`recent_rushing_team_grade_${(team && team.id) || 1}`
						)}
					isRankVisible={
						visibleRankModal ===
						`recent_rushing_team_grade_${(team && team.id) || 1}`
					}
					rankModalRef={rankModalRef}
					currentTeamRef={currentTeamRef}
					handleTeamClick={handleTeamClick}
					currentTeamId={team && team.id ? team.id : 0}
					hasLabel={true}
					hasRankModalEnabled={true}
					renderFrom="TeamFantasyFitnessScoreCard"
				/>
			</div>
		</div>
	);
};

export default TeamFantasyFitnessScoreCard;
